/*@flow*/
import React from 'react';
import Atlas from 'comps/App/Atlas';
import styled from '@emotion/styled';
import { type LonLatT } from 'store/types';
import studyAreaGeoJson from './studyAreaGeoJson';

const Container = styled.div(
  props => `
  position: relative;
  height: ${props.mapHeight || '100vh'};

  canvas {
    width: 100% !important;
  }

  .mapboxgl-ctrl-top-right {
    position: relative;
    top: 5px;
    right: 2px;
  }

  .mapboxgl-ctrl.mapboxgl-ctrl-group {
    button { background-color: white !important; }
    padding: 4px;
  }
`
);

const staticDecks = [
  {
    id: 'navigation',
    type: 'navigation',
    showZoom: true,
    showCompass: false,
    position: 'top-right',
  },
  {
    id: 'study-area',
    type: 'layer',
    placeBefore: 'road-label',
    config: {
      id: 'study-area',
      type: 'line',
      paint: {
        'line-color': 'yellow',
        'line-opacity': 0.5,
        'line-width': 4,
      },
      source: {
        type: 'geojson',
        data: {
          type: 'Feature',
          geometry: studyAreaGeoJson,
        },
      },
    },
  },
];

type PropsT = {|
  center?: LonLatT,
  decks?: Object[],
  zoom?: number,
  mapHeight?: string,
  children?: React$Node,
|};

const Component = (props: PropsT) => {
  let { center } = props;

  let decks = staticDecks.concat(props.decks || []);
  const zoom = props.zoom || 16;

  const config = {
    style: 'mapbox://styles/citiesense/cjsz3yh1dbjba1gkbz3lhve92',
    center,
    zoom,
    minZoom: Math.min(zoom, 12),
    attributionControl: true,
    customAttribution: 'Citiesense, Carto',
  };

  return (
    <Container className="map-container" mapHeight={props.mapHeight}>
      <Atlas decks={decks} config={config} />
      {props.children}
    </Container>
  );
};

export default Component;
